<template>
    <div class="created-user-table">
        <div class="card px-4">
            <div
                v-for="(row, idx) in tableData"
                :key="idx"
                class="created-user-table__row"
            >
                <div v-text="row.label" class="is-1 font-weight-bold" />
                <div class="d-flex align-items-center">
                    <span v-text="row.value" class="text-truncate" :class="row.class" />
                    <a-icon
                        v-if="row.icon && row.value"
                        v-tooltip="row.iconTooltip"
                        width="16"
                        class="text-orange cursor-pointer ml-2"
                        :icon="row.icon"
                        @click.native="copyToClipboard(row.value, idx)"
                    />
                    <transition name="fade">
                        <span
                            v-if="copiedIndex === idx"
                            v-text="'Skopiowano'"
                            class="ml-2 text-success text-sm"
                        />
                    </transition>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        userData: {
            type: Object,
            required: true
        }
    },
    data: () => ({
        copiedIndex: null
    }),
    computed: {
        tableData() {
            const { userAlias, login, password } = this.userData
            return [
                {
                    label: 'Link do aplikacji',
                    value: process.env.VUE_APP_DRS_MOBILE_URL,
                    class: 'text-underline',
                    icon: 'Copy',
                    iconTooltip: 'Skopiuj link do aplikacji'
                },
                {
                    label: 'Nazwa',
                    value: userAlias
                },
                {
                    label: 'Login',
                    value: login,
                    icon: 'Copy',
                    iconTooltip: 'Skopiuj login'
                },
                {
                    label: 'Hasło',
                    value: password,
                    class: 'cux-exclude'
                }
            ]
        }
    },
    methods: {
        copyToClipboard(text, idx) {
            window.navigator.clipboard.writeText(text)
            this.copiedIndex = idx
            setTimeout(() => {
                this.copiedIndex = null
            }, 2000)
        }
    }
}
</script>

<style lang="scss">
@import '@/styles/_custom.scss';
@import '~bootstrap/scss/mixins';
.created-user-table {
    display: flex;
    justify-content: center;
    .card {
        max-width: 700px;
        width: 100%;
    }
    &__row {
        display: flex;
        flex-direction: column;
        color: var(--color-primary);
        border-bottom: 1px solid var(--color-border);
        padding: 1rem 0;
        text-align: start;
        .a-icon {
            flex-shrink: 0;
        }
        &:last-child {
            border-bottom: none;
        }
        @include media-breakpoint-up(sm) {
            flex-direction: row;
            .is-1 {
                flex: 0 0 150px;
                max-width: 150px;
            }
        }
    }
    .fade-enter-active, .fade-leave-active {
        transition: opacity 0.5s;
    }
    .fade-enter, .fade-leave-to {
        opacity: 0;
    }
}
</style>